import { Description, Download } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import React from "react";
import { MessageProps } from "../../../interfaces/all";
import { resolveMediaUrl } from "../../../utils/media";
import MessageAvatar from "./MessageAvatar";
import MessageMetaInfo from "./MessageMetaInfo";
import { MessageContainer, MessageContent } from "./styles";

const DocumentMessage: React.FC<MessageProps> = ({
  message,
  showAvatar = true,
  showDate = true,
}) => {
  const isFromClient = message.sentBy === "client";
  const currentReadStatus = message.readStatus || { isRead: false };

  // Extrair dados do documento
  const content = message.content as any;
  const documentData = content.documentData || content.document || {};
  const rawUrl = documentData.url || documentData.mediaUrl || "";
  const url = resolveMediaUrl(rawUrl);
  const filename = documentData.filename || "Documento";

  const handleDownload = () => {
    if (!url) return;
    window.open(url, "_blank");
  };

  return (
    <MessageContainer isFromClient={isFromClient} showTriangle={showAvatar}>
      {isFromClient ? (
        <>
          <MessageAvatar sentBy={message.sentBy} showAvatar={showAvatar} />
          <MessageContent
            isFromClient={isFromClient}
            showTriangle={showAvatar}
            sx={{ pr: "62px", position: "relative", minWidth: 240 }}
          >
            <Box
              sx={{ display: "flex", alignItems: "center", gap: "12px", py: 1 }}
            >
              <Description color="primary" sx={{ fontSize: 32 }} />
              <Box sx={{ flex: 1, overflow: "hidden" }}>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 500,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {filename}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Documento
                </Typography>
              </Box>
              <IconButton
                onClick={handleDownload}
                size="small"
                sx={{ color: "inherit" }}
              >
                <Download fontSize="small" />
              </IconButton>
            </Box>
            <MessageMetaInfo
              message={message}
              showDate={showDate}
              isFromClient={isFromClient}
              readStatus={currentReadStatus}
            />
          </MessageContent>
        </>
      ) : (
        <>
          <MessageContent
            isFromClient={isFromClient}
            showTriangle={showAvatar}
            sx={{ pr: "62px", position: "relative", minWidth: 240 }}
          >
            <Box
              sx={{ display: "flex", alignItems: "center", gap: "12px", py: 1 }}
            >
              <Description
                sx={{ fontSize: 32, color: "rgba(255,255,255,0.9)" }}
              />
              <Box sx={{ flex: 1, overflow: "hidden" }}>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 500,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {filename}
                </Typography>
                <Typography variant="caption" sx={{ opacity: 0.8 }}>
                  Documento
                </Typography>
              </Box>
              <IconButton
                onClick={handleDownload}
                size="small"
                sx={{ color: "inherit" }}
              >
                <Download fontSize="small" />
              </IconButton>
            </Box>
            <MessageMetaInfo
              message={message}
              showDate={showDate}
              isFromClient={isFromClient}
              readStatus={currentReadStatus}
            />
          </MessageContent>
          <MessageAvatar sentBy={message.sentBy} showAvatar={showAvatar} />
        </>
      )}
    </MessageContainer>
  );
};

export default DocumentMessage;
